import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { AuthOpenIdService } from 'src/app/_Services/auth/auth-open-id-service';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

export const authApihInterceptor: HttpInterceptorFn = (req, next) => {
  console.log('[Interceptor] URL:', req.url);
  console.log('[Interceptor] apiEndpoint:', environment.apiEndpoint);
  console.log('[Interceptor] Match:', req.url.startsWith(environment.apiEndpoint));

  if (!req.url.startsWith(environment.apiEndpoint)) {
    return next(req);
  }

  const authService = inject(AuthOpenIdService);
  const router = inject(Router);

  const addToken = (token: string | null) => {
    console.log('[Interceptor] Token present:', !!token);
    if (token) {
      return req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
      });
    }
    return req;
  };

  return next(addToken(authService.getAccessTokenSync())).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return from(authService.refreshToken()).pipe(
          switchMap((success) => {
            if (success) {
              return next(addToken(authService.getAccessTokenSync()));
            }
            router.navigate(['/auth/login']);
            return throwError(() => error);
          }),
          catchError(() => {
            router.navigate(['/auth/login']);
            return throwError(() => error);
          })
        );
      }
      return throwError(() => error);
    })
  );
};
